<div class="app-action-tablet-header-station-tab" [ngClass]="{'selected': selected}" (click)="selectTab()">
    <sc-padding>
        <sc-flex [centered]="true" >
            <div class="label">{{stationName}}</div>
            <sc-content-spacer *ngIf="selected"></sc-content-spacer>
            <div class="close-action" *ngIf="selected"><sc-icon iconClass="fa-times close-btn" (click)="closeTab()"></sc-icon></div>
        </sc-flex>
    </sc-padding>
</div>